export const CallJobsTypes = {
  ICallJobsService: Symbol("ICallJobsService"),
};
